import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueI18n from "vue-i18n";

import { sync } from "vuex-router-sync";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "./assets/app.scss";
import "./assets/style.css";

import VModal from "vue-js-modal";
Vue.use(VModal, { dialog: true });

const unsync = sync(store, router);

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// Vue 18n and locales
Vue.use(VueI18n);

import { languages, defaultLocale } from "../locales";
const messages = Object.assign(languages);

let locale = navigator.language.split("-")[0];

if (window.localStorage.getItem("automato_user_language")) {
  locale = window.localStorage.getItem("automato_user_language");
}

let i18n = new VueI18n({
  locale: Object.keys(languages).includes(locale) ? locale : defaultLocale,
  fallbackLocale: "en",
  messages,
});

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
